import { useAppState } from 'components/contexts/State';
import { Navigate } from 'react-router-dom';
import { ROUTE_PATHS } from 'routes';

export default function ProtectedDataRepoRoute({ children }) {
  const { userRoleDetails } = useAppState();

  if (
    userRoleDetails &&
    userRoleDetails.resources &&
    (userRoleDetails.resources.includes('data_repo_self_view') ||
      userRoleDetails.resources.includes('data_repo_all_view'))
  ) {
    return children;
  }

  return <Navigate to={ROUTE_PATHS.DEFAULT} />;
}
